export default class OptionCrane {
    constructor() {
    }
    getHtml = function(){
        return `
<div class="crane_car a">
    <h2 class="title1">기종선택</h2>
    <div class="flex">
        <div class="left flex_column main-button-area">
            <div class="item flex" data-index="1" data-range="1~4">카고</div>
            <div class="item flex" data-index="2" data-range="5~7">소형</div>
            <div class="item flex" data-index="3" data-range="8~15">하이드로</div>
            <div class="item flex" data-index="4" data-range="12~15">대형</div>
        </div>
        <div class="right flex_column sub-button-area">
            <div class="flex" data-index="1">
                <div class="item flex" data-index="1" data-code="310">5T</div>
                <div class="item flex" data-index="2" data-code="312">11T</div>
                <div class="item flex" data-index="3" data-code="314">18T</div>
                <div class="item flex" data-index="4" data-code="316">25T</div>
            </div>
            <div class="flex" data-index="2">
                <div class="item flex" data-index="5" data-code="320">10T</div>
                <div class="item flex" data-index="6" data-code="322">13T</div>
                <div class="item flex" data-index="7" data-code="324">16T</div>
                <div class="item flex op0"></div>
            </div>
            <div class="flex" data-index="3">
                <div class="item flex" data-index="8" data-code="330">25T</div>
                <div class="item flex" data-index="9" data-code="332">35T</div>
                <div class="item flex" data-index="10" data-code="334">50T</div>
                <div class="item flex" data-index="11" data-code="336">60T</div>
            </div>
            <div class="flex" data-index="4">
                <div class="item flex" data-index="12" data-code="340">70T</div>
                <div class="item flex" data-index="13" data-code="342">100T</div>
                <div class="item flex" data-index="14" data-code="344">160T</div>
                <div class="item flex" data-index="15" data-code="346">200T</div>
            </div>
        </div>
    </div>
    <h2 class="title1">옵션선택</h2>
    <div class="option flex_column">
        <div class="division_3 flex">
            <select class="item-select" data-value="고릴라" data-code="350" data-constraint="X:M:2" data-constraint-errmsg="고릴라 옵션은 소형만 가능합니다.">
                <option value="">고릴라옵션 미선택</option>
                <option value="고릴라제외">고릴라제외</option>
                <option value="고릴라만">고릴라만</option>
            </select>
            <select class="item-select" data-value="이동거리">
                <option value="">이동거리</option>
                <option value="10">10 km이내</option>
                <option value="50">50 km 이내</option>
                <option value="90">90 km 이내</option>
                <option value="130">130 km 이내</option>
                <option value="200">200 km 이내</option>
                <option value="250">250 km 이내</option>
                <option value="300">300 km 이내</option>
                <option value="350">350 km 이내</option>
                <option value="400">400 km 이내</option>
                <option value="500">500 km 이내</option>
            </select>
            <select class="item-select" data-value="전고">
                <option value="">전고</option>
            </select>
        </div>
        <div class="division_3 flex">
            <div class="item flex" data-value="컨테이너운반" data-code="340" data-constraint="X:M:1" data-constraint-errmsg="컨테이너운반 옵션은 카고만 가능합니다.">
                컨테이너운반
            </div>
            <div class="item flex" data-value="압축기" data-code="320">
                압축기
            </div>
            <div class="item flex op0"></div>
        </div>
    </div>
    <div class="car-example"></div>
    <div class="blank"></div>
    <div class="button flex apply-data">
        <div class="button_yellow flex">완료</div>
    </div>
</div>`;
    }
    /**
     * 화면 초기화
     * @param parent OptionWindow 인스턴스
     */
    init = function(parent) {
        this.parent=parent;
        console.log('window.option.crane.init');
        this.parent.load();// 변수 초기화
        this.parent.drawJungo();// 전고 그리기 ( 최초한번만 )
        this.parent.draw();// 톤수,미터를 그린다.
        this.parent.initMainButtonHandler();// 메인 버튼을 클릭했을때
        this.parent.initSubButtonHandler();// 서브 버튼을 클릭했을때
        this.parent.initOptionHandler();// 옵션버튼 클릭시
        this.parent.initApplyHandler();// 완료버튼 클릭시
    }
    /**
     * car_range 값을 업데이트한다.
     */
    updateRange = function (){
        const self = this;
        const arr = [];
        // 서브버튼 순회
        $('#'+this.parent.id+" .sub-button-area .item").each(function(){
            const idx = $(this).attr('data-index');
            if( self.parent.subIdxList.includes(idx) ) arr.push( $(this).attr('data-code'));
        });

        // const arr = this.parent.subCodeList;
        const min = Math.min(...arr);
        const max = Math.max(...arr);
        let range = '';
        range = `${min}~${max}`;
        const data = this.parent.data;
        data['car_range']=range;
    }
}
